import React, { useState } from "react";
import { Loading } from "../Loading/Loading";

const ModalLogsInformation = ({ isVisible, onClose, onFetchLogs }) => {
    const [selectedLogType, setSelectedLogType] = useState("");
    const [logsData, setLogsData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const logTypes = [
        "dbtables",
        "pod_deploy",
        "pod_reset",
        "pod_delete",
        "streaming",
    ];

    const handleFetchLogs = async () => {
        if (!selectedLogType) {
            alert("Please select a log type.");
            return;
        }
        setIsLoading(true);
        try {
            const logs = await onFetchLogs(selectedLogType);
            setLogsData(logs);
        } catch (error) {
            console.error("Error fetching logs:", error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleLogTypeChange = (e) => {
        setSelectedLogType(e.target.value);
        setLogsData([]); // Clear logs when changing log type
    };

    if(isLoading){
         return <Loading />;
    }

    return (
        isVisible && (
            <div className="bg-gray-800 bg-opacity-75 fixed inset-0 flex items-center justify-center z-[100]">
                <div className="bg-gray-900 p-6 rounded-lg shadow-lg text-white w-[80%] h-[85%] flex flex-col">
                    <h2 className="text-xl font-bold mb-4 text-center">
                        Logs Visualization
                    </h2>
                    <div className="mb-4">
                        <label htmlFor="logType" className="font-bold block mb-2">
                            Select a log type:
                        </label>
                        <select
                            id="logType"
                            value={selectedLogType}
                            onChange={handleLogTypeChange}
                            className="w-full bg-gray-700 rounded-lg p-2 text-white"
                        >
                            <option value="">Select...</option>
                            {logTypes.map((type) => (
                                <option key={type} value={type}>
                                    {type}
                                </option>
                            ))}
                        </select>
                    </div>
                    <button
                        onClick={handleFetchLogs}
                        disabled={isLoading}
                        className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-lg mb-4 self-center"
                    >
                        {"Fetch Logs"}
                    </button>
                    <div className="flex-grow bg-gray-800 rounded-lg p-4 text-xs flex gap-4 overflow-hidden">
                        {logsData.length > 0 ? (
                            logsData.map(({ type, logs }, index) => (
                                <div
                                    key={index}
                                    className="flex-1 bg-gray-900 p-2 rounded-lg border border-gray-700 overflow-hidden"
                                >
                                    <h3 className="font-bold text-lg mb-2 text-center">
                                        {type.toUpperCase()} Logs
                                    </h3>
                                    <div className="overflow-y-scroll h-[calc(100%-2.5rem)]">
                                        {/* 2.5rem es para ajustarse al tamaño del título */}
                                        <pre className="whitespace-pre-wrap break-words">
                                            {logs}
                                        </pre>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-gray-400 text-center w-full">
                                Select a log type and click "Fetch Logs".
                            </p>
                        )}
                    </div>
                    <button
                        onClick={onClose}
                        className="mt-4 bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-lg self-center"
                    >
                        Close
                    </button>
                </div>
            </div>
        )
    );
};

export default ModalLogsInformation;
